<template>
  <section class="about-category" @mousemove="getCursorPosition">
    <div class="about-category__wrapper">
      <BaseTitle class="about-category__title" :text="titleText" />
      <ul class="about-category__list">
        <li
          v-for="(category, index) in categories"
          :key="index"
          @click="getCategoryId(++index)"
          class="about-category__item"
        >
          <BaseAnimation
            :attr="{
              opacity: 1,
              y: 0,
              delay: 0.25 * index
            }"
          >
            <ShapeListLink :item="category" :index="index" />
          </BaseAnimation>
        </li>
      </ul>
      <AboutPageSmallAnimation :position="{ x, y }" />
    </div>
  </section>
</template>

<script>
import ShapeListLink from '~/components/ShapeListLink'
import AboutPageSmallAnimation from '~/components/AboutPageSmallAnimation'

export default {
  data() {
    return {
      x: 0,
      y: 0
    }
  },
  computed: {
    titleText() {
      return this.messages.about.aboutCategory.title
    },
    categories() {
      return this.messages.about.aboutCategory.categories
    }
  },
  components: {
    ShapeListLink,
    AboutPageSmallAnimation
  },
  methods: {
    getCursorPosition({ x, y }) {
      ;(this.x = x), (this.y = y)
    },
    getCategoryId(id) {
      this.$store.commit('participants/SET_ID', `category${id}`)
    }
  }
}
</script>

<style lang="scss">
.about-category {
  &__wrapper {
    @include container;

    position: relative;
    padding: 0 16px 288px;

    &::before {
      content: '';
      position: absolute;
      z-index: -1;
      bottom: 100px;
      left: -216px;
      width: 1364px;
      height: 608px;
      background: url('~/static/img/about-category-bg@mb.svg') no-repeat center;
      background-size: cover;
    }
  }

  &__title {
    margin: 0 0 10px;
  }

  &__list {
    position: relative;
    z-index: 1;
    margin: 0;
    padding: 0;
    list-style: none;
    counter-reset: list;
  }

  &__item {
    &:not(:last-of-type) {
      margin-bottom: 40px;
    }

    &:nth-of-type(1) {
      height: 205px;

      a {
        &::after {
          width: 191px;
          height: 175px;
          background: url('~/static/img/about-category-1.svg') no-repeat center;
          background-size: cover;
        }
      }
    }

    &:nth-of-type(2) {
      height: 195px;

      a {
        &::after {
          width: 193px;
          height: 161px;
          background: url('~/static/img/about-category-2.svg') no-repeat center;
          background-size: cover;
        }
      }
    }

    &:nth-of-type(3) {
      height: 206px;

      a {
        &::after {
          width: 191px;
          height: 174px;
          background: url('~/static/img/about-category-3.svg') no-repeat center;
          background-size: cover;
        }
      }
    }

    a {
      position: relative;
      opacity: 0;
      transform: translate3d(0, -30px, 0);

      &::after {
        @include horizontal-center;

        content: '';
        position: absolute;
        z-index: -1;
        top: 0;
      }
    }

    @for $i from 1 through 3 {
      &:nth-of-type(#{$i}) {
        .animation-number {
          animation: 2s ease-in #{$i}s infinite alternate swing;
        }
      }
    }
  }

  &__inner {
    position: relative;
    width: 191px;
    height: 175px;
    margin: 0 auto;
  }

  .animation-number {
    position: absolute;
    left: 0;
    bottom: -30px;

    &:nth-of-type(1) {
      img {
        width: 72px;
        height: 72px;
      }
    }

    &:nth-of-type(2) {
      img {
        width: 68px;
        height: 67px;
      }
    }

    &:nth-of-type(3) {
      img {
        width: 66px;
        height: 75px;
      }
    }
  }

  .caption {
    @include horizontal-center;

    margin: 0;
    top: 70px;
    text-align: center;
  }
}

@include media-min($tablet-width) {
  .about-category {
    &__wrapper {
      padding: 0 25px 321px;

      &::before {
        left: -500px;
        bottom: 100px;
        width: 1932px;
        height: 445px;
        background: url('~/static/img/about-category-bg@tl.svg') no-repeat
          center;
        background-size: cover;
      }
    }

    &__title {
      margin-bottom: 56px;
    }

    &__list {
      display: flex;
      justify-content: space-between;
    }

    &__item {
      flex-basis: 30%;
      flex-grow: 1;

      &:not(:last-of-type) {
        margin: 0;
      }
    }

    .caption {
      top: 60px;
    }
  }
}

@include media-min($desktop-width) {
  .about-category {
    &__wrapper {
      padding: 0 60px 427px;

      &::before {
        bottom: 135px;
        left: -270px;
        width: 1896px;
        height: 623px;
        background: url('~/static/img/about-category-bg@dt.svg') no-repeat
          center;
        background-size: cover;
      }
    }

    &__title {
      margin-bottom: 55px;
    }

    &__item {
      &::before {
        font-size: 34px;
        line-height: 45px;
      }

      &:not(:last-of-type) {
        margin: 0;
      }

      &:nth-of-type(1) {
        width: 309px;
        height: 309px;

        a {
          &::after {
            width: 309px;
            height: 284px;
          }
        }
      }

      &:nth-of-type(2) {
        width: 310px;
        height: 307px;

        a {
          &::after {
            width: 312px;
            height: 261px;
          }
        }
      }

      &:nth-of-type(3) {
        width: 309px;
        height: 309px;

        a {
          &::after {
            width: 311px;
            height: 284px;
          }
        }
      }
    }

    &__inner {
      width: 309px;
      height: 284px;
    }

    .caption {
      top: 120px;
    }

    .animation-number {
      &:nth-of-type(1) {
        img {
          width: 119px;
          height: 93px;
        }
      }

      &:nth-of-type(2) {
        img {
          width: 123px;
          height: 93px;
        }
      }

      &:nth-of-type(3) {
        img {
          width: 119px;
          height: 93px;
        }
      }
    }
  }
}

@include media-min($monoblock-width) {
  .about-category {
    &__wrapper {
      &::before {
        bottom: 135px;
        left: 50%;
        width: 3207px;
        height: 696px;
        background: url('~/static/img/about-category-bg@mn.svg') no-repeat
          center;
        background-size: cover;
        transform: translateX(-50%);
      }
    }
  }
}

@keyframes swing {
  0% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(10deg);
  }
  50% {
    transform: rotate(-5deg);
  }
  75% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(5deg);
  }
}
</style>



// WEBPACK FOOTER //
// components/AboutCategoryBlock.vue